// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1xkMs","inputWrap":"CustomTip_inputWrap__2VfFL"};